import React from "react";
import { personalInfo } from "../data/mock";

const Toolbar = ({ kernel, filename, onRun, filesOpen, onFilesToggle }) => (
  <header className="tb">
    <a className="skip" href="#nb-main">
      Skip to notebook
    </a>
    <div className="tb-row">
      <div className="tb-file">
        <span className="tb-ext" aria-hidden="true">
          {(filename || personalInfo.filename).split(".").pop()?.slice(0, 3) || "py"}
        </span>
        <span className="tb-name">{filename || personalInfo.filename}</span>
      </div>

      <p className="tb-kernel">
        <span className={`tb-dot ${kernel}`} aria-hidden="true" />
        <span>
          Kernel: {personalInfo.kernel} ({kernel})
        </span>
      </p>

      <nav className="tb-actions" aria-label="Primary">
        <button type="button" className="btn btn-ghost" onClick={onRun}>
          Run
        </button>
        <a className="btn btn-ghost" href={personalInfo.cv} download>
          Download CV
        </a>
        <a className="btn btn-solid" href={`mailto:${personalInfo.email}`}>
          Email
        </a>
        <button
          type="button"
          className="tb-toc-btn"
          aria-expanded={filesOpen}
          aria-controls="nb-files-panel"
          onClick={onFilesToggle}
        >
          Files
        </button>
      </nav>
    </div>
  </header>
);

export default Toolbar;
